import Changelog from '@/pages/Various/Changelog.vue';
import Feedback from '@/pages/Various/Feedback.vue';
import Project from '@/pages/Various/Project.vue';
import Subscribed from '@/pages/Various/Subscribed.vue';
import context from '@/router/guards/context';
export default [
    {
        path: 'subscribed',
        name: 'subscribed',
        component: Subscribed,
    },
    {
        path: 'authorized',
        name: 'authorized',
        redirect: { name: 'settings.contract' },
    },
    {
        path: 'feedback',
        name: 'feedback',
        component: Feedback,
        beforeEnter: [context],
    },
    {
        path: 'project',
        name: 'project',
        component: Project,
        beforeEnter: [context],
    },
    {
        path: 'changelog',
        name: 'changelog',
        component: Changelog,
    },
];
